import React, { useCallback } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';

import { AuthActions, AuthState } from 'store/ducks/auth';
import { useTranslation } from 'hooks';
import { translations } from './translations';
import { Popover, PopoverContent, PopoverTrigger } from 'components/ui/popover';
import { ShieldAlert } from 'lucide-react';

import * as S from './styles';

export const User: React.FC = () => {
  const dispatch = useDispatch();
  const { getTranslation } = useTranslation(translations);
  const { data: userData } = useSelector<RootStateOrAny>(
    (state) => state.auth
  ) as AuthState;

  const handleLogout = useCallback(() => {
    dispatch(AuthActions.logoutRequest());
  }, [dispatch]);

  const getUserName = React.useCallback(() => {
    const base = userData?.name?.split(' ')[0] || '';
    const impersonate = userData?.userImpersonate?.name;

    const compImpersonate = (
      <Popover>
        <PopoverTrigger asChild title={impersonate}>
          <S.Name>
            {base}
            <ShieldAlert className="ml-2" />
          </S.Name>
        </PopoverTrigger>

        <PopoverContent className="w-50 p-4 rounded-xl shadow-lg border bg-white z-50">
          <div className="text-sm font-medium text-gray-700">
            {getTranslation('logged_in_as')}
            <div className="mt-1 text-gray-900 font-semibold italic">
              {impersonate}
            </div>
          </div>
        </PopoverContent>
      </Popover>
    );

    return impersonate ? compImpersonate : <S.Name>{base}</S.Name>;
  }, [userData, getTranslation]);

  return (
    <S.Container>
      {getUserName()}
      <S.Logout onClick={handleLogout}>{getTranslation('sair')}</S.Logout>
    </S.Container>
  );
};
